<!-- The about page is formatted using vue-simple-accordion -->
<!-- Ref link for vue-simple-accordion: https://developer.aliyun.com/mirror/npm/package/vue-simple-accordion/v/0.0.1?spm=a2c6h.14275010.0.0.5b183b77r1qw2f&file=0.0.1 -->
<template>
    <div>
        <h1>ABOUT NEURON</h1>
        <vsa-list>
            <vsa-item>
                <vsa-heading>
                    What is NEURON?
                </vsa-heading>
                <vsa-content>
                    <div class="indented">
                        NEURON (<b><u>N</u></b>atural Languag<b><u>E</u></b> <b><u>U</u></b>nderstanding of Que<b><u>R</u></b>y Executi<b><u>O</u></b>n Pla<b><u>N</u></b>) is a novel system
                        that facilitates natural language interaction with <i>query execution plan</i> (QEP), which represents an execution strategy for an SQL query, to enhance its
                        understanding. The existing version (version 1.0) of NEURON is developed based on <i>NEURON: Query Execution Plan Meets Natural Language Processing For Augmenting
                        DB Education</i> published in SIGMOD 2019. In this version, NEURON accepts an SQL query (which may include joins, aggregation, nesting, among other things) as input, executes it, and generates a <i>simplified</i>
                        natural language description (both in text and voice form) of the execution strategy deployed by the underlying RDBMS. Furthermore, it facilitates understaning of various
                        features related to a QEP through a <i>natural language question answering</i> (NLQA) framework. NEURON, world's first of its kind, is a tool that can greatly enhance
                        students' learning of the query optimization topic.
                        <br /><br />
                        Future version will incorporate features described in <i>Towards Enhancing Database Education: Natural Language Generation Meets Query Execution Plans</i> (in SIGMOD 2021).
                        <br /><br /><b><u>NOTE:</u></b> NEURON is not a query processor. As such, it does not return the result of a query. Instead, the focus of NEURON is the natural language translation of the QEP
                        and the interactive NLQA.
                    </div>
                </vsa-content>
            </vsa-item>
            <vsa-item>
                <vsa-heading>
                    Who developed NEURON?
                </vsa-heading>
                <vsa-content>
                    <div class="indented">
                        NEURON is jointly developed by a team of faculty and students in Nanyang Technological University (NTU, Singapore) and Xidian University (China).<br /><br />
                        <strong>Faculty members:</strong>
                        <ul>
                            <li><a href="https://www3.ntu.edu.sg/home/assourav/index.html" active target="_blank">Sourav S. Bhowmick</a> (NTU)</li>
                            <li><a href="https://raihanjoty.github.io/" active target="_blank">Shafiq R. Joty</a> (NTU)</li>
                            <li><a href="https://lihuixidian.github.io//" active target="_blank">Hui Li</a> (Xidian)</li>
                        </ul>
                        <br />
                        <strong>Student members:</strong>
                        <ul>
                            <li>Siyuan Liu (NTU)</li>
                            <li>Wanlu Zhang (NTU)</li>
                            <li>Shu Wang (NTU)</li>
                            <li>Wanyi Huang (NTU)</li>
                            <li>Weiguo Wang (Xidian)</li>
                            <li>Peng Chen (Xidian)</li>
                        </ul>
                    </div>
                </vsa-content>
            </vsa-item>
            <vsa-item>
                <vsa-heading>
                    Where can I find more information regarding NEURON?
                </vsa-heading>
                <vsa-content>
                    <div class="indented">
                        <strong>Publications:</strong>
                        <ul>
                            <li>Liu et al. NEURON: Query Execution Plan Meets Natural Language Processing For Augmenting DB Education.
                            <i>In ACM SIGMOD, 2019</i>. [<a href="https://www3.ntu.edu.sg/home/assourav/papers/SIGMOD-19-NEURON.pdf" active target="_blank">PDF</a>]
                            [<a href="https://www.youtube.com/watch?v=wRIWuYbU2F0" active target="_blank">video</a>]</li>
                            <li>Wang et al. Towards Enhancing Database Education: Natural Language Generation Meets Query Execution Plans.
                            <i>In ACM SIGMOD, 2021</i>.</li>
                        </ul>
                    </div>
                </vsa-content>
            </vsa-item>
            <vsa-item>
                <vsa-heading>
                    Contact Us
                </vsa-heading>
                <vsa-content>
                    <div class="indented">
                        For feedback and comments, please email to <a href="mailto:ASSourav@ntu.edu.sg">ASSourav@ntu.edu.sg</a>.
                    </div>
                </vsa-content>
            </vsa-item>
        </vsa-list>
        <!-- router -->
        <router-view></router-view>
    </div>
</template>
<script>
import {
  VsaList,
  VsaItem,
  VsaHeading,
  VsaContent
} from 'vue-simple-accordion';
//import '@/assets/css/vue-simple-accordion.css';
import 'vue-simple-accordion/dist/vue-simple-accordion.css';
export default {
  name: "About",
  components: {
    VsaList,
    VsaItem,
    VsaHeading,
    VsaContent
  }
}
</script>